import axios from 'axios';
import { useEffect, useReducer } from 'react';
import { systemCode, xs_languageCode } from '..';
import { dataFetchReducer } from './utils/dataFetchReducer';
import { parseFastbetData } from './parseFastbetData';
import { getConfiguration } from './utils/configuration';

export async function getFastBetData(callbackSuccess, callbackError) {
	const url = getConfiguration().api.getAutocompleteDataBatch;
    const params = {
        systemCode : systemCode,
        lingua: xs_languageCode,
        hash: ''
    }
    
    try {
        const result = await axios.post(url, null, {params: params});
        let data = parseFastbetData(result.data);
        callbackSuccess(data);   
    } 
    catch (error) {
    	if(typeof callbackError === 'function'){
    		callbackError(error);    		
    	}
    }
}

export function useFetchFastbetData() {
	const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

		const url = getConfiguration().api.getAutocompleteDataBatch;
        const params = {
            systemCode : systemCode,
            lingua: xs_languageCode,
            hash: ''
        }
       
        fetchData(url, params,(response) => {
            if (response != null) {
                let data = parseFastbetData(response);
                dispatch({ type: 'FETCH_SUCCESS', payload: data });            		
            }
        });

        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch];
}
